import { useEffect, useState } from "react";
import { setAuthToken } from "../api/api";
import Table from "../components/Table";
import TradeForm from "../components/TradeForm";
import TradeFormModal from "../components/TradeFormModal";
import CoinDetailsModal from "../components/CoinDetailModal";

export default function Market() {
  const [isMobileTradeOpen, setIsMobileTradeOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedCoin, setSelectedCoin] = useState(null);
  const [selectedCoinDetail, setSelectedCoinDetail] = useState(null);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.includes('access_token=')) {
      const token = new URLSearchParams(hash.replace('#', '?')).get('access_token');
      if (token) {
        setAuthToken(token);
        window.location.hash = '';
      }
    }
  }, []);

  const openMobileTrade = (coin) => {
    setSelectedCoin(coin);
    setIsMobileTradeOpen(true);
  }

  const closeMobileTrade = () => {
    setSelectedCoin(null);
    setIsMobileTradeOpen(false);
  }

  const openCoinDetails = (coinDetail) => {
    setSelectedCoinDetail(coinDetail);
  };

  const closeCoinDetails = () => {
    setSelectedCoinDetail(null);   // close coin detail modal
    setSelectedRowId(null);        // unselect highlighted row
  };

  const handleTradeClick = (coin) => {
    setSelectedCoin(coin);      // For prefilling TradeForm
    closeCoinDetails();         // Close modal and clear selectedCoinDetail
    setSelectedRowId(null);     // Unselect row highlight immediately
  };

  return (
    <div className="container flex justify-between items-start mx-auto px-4 lg:px-0">
      <Table
        onMobileTrade={openMobileTrade}
        onRowClick={(coinDetail) => {
          openCoinDetails(coinDetail);
          setSelectedRowId(coinDetail.id);  // Highlight row when modal opens
          }}
          selectedCoinId={selectedRowId}      // Highlight selected row
      />
      <TradeForm initialCoin={selectedCoin} />
      {isMobileTradeOpen && (
        <TradeFormModal onClose={closeMobileTrade}>
          <TradeForm initialCoin={selectedCoin} onClose={closeMobileTrade} isVisible={isMobileTradeOpen} />
        </TradeFormModal>
      )}
      {selectedCoinDetail && (
        <CoinDetailsModal
          {...selectedCoinDetail}
          onClose={closeCoinDetails}
          onTradeClick={handleTradeClick}
        />
      )}
    </div>
  )
};